import axios from './financeiroApi';

const getPath = () => `/api/v1/backend/cliente`;

const getParams = (params) => {
  let newParams;
  if (params?.filtroAvancado) {
    newParams = {
      ...params,
      ...params.filtroAvancado,
    };
    delete newParams.filtroAvancado;
  } else {
    newParams = params;
  }

  newParams = {
    ...newParams,
    uf: newParams?.pessoa?.endereco?.uf?.nome,
  };

  return newParams;
};

const clienteApi = {
  get: (search) => {
    const url = `${getPath()}`;
    return axios.get(url, { params: getParams(search) });
  },
  getOne: (clienteId) => {
    const url = `${getPath()}/${clienteId}`;
    return axios.get(url);
  },
  getAll: () => {
    return axios.get(`${getPath()}/buscarClientesCompletos`);
  },
  put: (cliente) => {
    const url = `${getPath()}/${cliente.id}`;
    return axios.put(url, cliente);
  },
  post: (cliente) => {
    const url = `${getPath()}`;
    return axios.post(url, cliente);
  },
  delete: (filtro) => {
    return axios.delete(getPath(), { data: filtro });
  },
  pesquisar: (params) => {
    return axios.get(`${getPath()}/pesquisar`, { params });
  },
  buscarClienteCompleto: (params) => {
    return axios.get(`${getPath()}/buscarClientesCompletos`, { params });
  },
  atualizarListaClientes: (lista) => {
    return axios.put(`${getPath()}/listaClientes`, lista);
  },
  obterModelo: () => {
    return axios.get(`${getPath()}/modelo`);
  },
  importar: async (arquivo, idNotificacao) => {
    try {
      return axios.post(`${getPath()}/importar?idNotificacao=${idNotificacao}`, arquivo, {
        headers: {
          'Content-Type': 'multipart/form-data',
          type: 'formData',
        },
      });
    } catch (error) {
      throw error;
    }
  },
};

export { clienteApi };
